function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundsproof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3778 6.99838C24.4975 6.89276 24.6516 6.83448 24.8112 6.83448H28.6637C29.0255 6.83448 29.3188 7.12781 29.3188 7.48965V40.5103C29.3188 40.8722 29.0255 41.1655 28.6637 41.1655H24.8112C24.6516 41.1655 24.4975 41.1072 24.3778 41.0016L15.2077 32.9103H5.65517C5.29333 32.9103 5 32.617 5 32.2552V15.7448C5 15.383 5.29333 15.0897 5.65517 15.0897H11.3788C11.7406 15.0897 12.0339 15.383 12.0339 15.7448C12.0339 16.1067 11.7406 16.4 11.3788 16.4H6.31034V31.6H15.4554C15.615 31.6 15.7692 31.6583 15.8889 31.7639L25.059 39.8552H28.0085V8.14483H25.059L16.1106 16.0405V28.1785C16.1106 28.5404 15.8172 28.8337 15.4554 28.8337C15.0935 28.8337 14.8002 28.5404 14.8002 28.1785V15.7448C14.8002 15.5568 14.881 15.3779 15.0219 15.2536L24.3778 6.99838Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8333 15.4655C32.0507 15.1762 32.4615 15.1179 32.7507 15.3353C35.5078 17.4075 37.0889 20.5732 37.0889 24.0123C37.0889 27.4515 35.5037 30.6214 32.7506 32.6894C32.4613 32.9068 32.0506 32.8484 31.8332 32.5591C31.6159 32.2698 31.6743 31.8591 31.9636 31.6418C34.3878 29.8207 35.7785 27.0387 35.7785 24.0123C35.7785 20.9859 34.3918 18.2079 31.9635 16.3828C31.6742 16.1654 31.6159 15.7547 31.8333 15.4655Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7061 11.3889C35.9234 11.0996 36.3341 11.0413 36.6234 11.2586C40.6728 14.301 43 18.9547 43 24.0123C43 29.07 40.6728 33.7237 36.6234 36.766C36.3341 36.9834 35.9234 36.9251 35.7061 36.6358C35.4887 36.3465 35.547 35.9358 35.8363 35.7184C39.557 32.9231 41.6897 28.6571 41.6897 24.0123C41.6897 19.3676 39.557 15.1016 35.8363 12.3063C35.547 12.0889 35.4887 11.6782 35.7061 11.3889Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1919 5.1919C5.44776 4.93603 5.86259 4.93603 6.11845 5.1919L42.8081 41.8815C43.064 42.1374 43.064 42.5522 42.8081 42.8081C42.5522 43.064 42.1374 43.064 41.8815 42.8081L5.1919 6.11845C4.93603 5.86259 4.93603 5.44776 5.1919 5.1919Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundsproof);
export default __webpack_public_path__ + "static/media/Soundsproof.88b9627d53e209555843cfed7d45cb0b.svg";
export { ForwardRef as ReactComponent };